import { gql } from "@apollo/client";

export const CREATE_CAMPAIGN_NAME = gql`
mutation CreateCampaign($campaignInput: CampaignInput!) {
  createCampaign(campaignInput: $campaignInput) {
    campaignId
    campaignName
    campaignType
  }
}
`

export const ADD_CAMPAIGN_DATA = gql`
mutation AddCampaignData($campaignDataInput: CampaignDataInput!) {
  addCampaignData(campaignDataInput: $campaignDataInput) {
    campaignId
    campaignName
  }
}
`

export const GET_CAMPAIGN_DETAILS_BY_ID = gql`
mutation GetAllSequences($getSequenceArgs: AllSequenceArgs!) {
  getAllSequences(getSequenceArgs: $getSequenceArgs) {
    campaignId
    campaignName
    campaignType
    campaignStarted
		campaignStatus
    sequence {
      _id
      message
      order
      seqType
      subject
      waitFor
    }
  }
}
`

export const ADD_SEQUENCE_DATA = gql`
mutation AddCampaignSequences($addSequenceInput: AddSequenceType!) {
  addCampaignSequences(addSequenceInput: $addSequenceInput) {
    campaignId
    campaignName
    sequence {
      _id
      message
      order
      seqType
      subject
      waitFor
    }
  }
}
`


export const UPDATE_CAMPAIGN_STATUS = gql`
mutation UpdateCampaignStatus($updateCampaignStatusInput: UpdateCampaignStatusInput!) {
  updateCampaignStatus(updateCampaignStatusInput: $updateCampaignStatusInput)
}
`

export const UPDATE_CAMPAIGN_TYPE = gql`
mutation updateCampaignType($updateCampaignTypeInput: UpdateCampaignTypeInput!){
		updateCampaignType(updateCampaignTypeInput: $updateCampaignTypeInput){
		campaignId
		campaignName
		campaignStarted
		campaignStatus
		campaignType
	}
	}
`